import { automationsConstants } from '@constants/automations';

const initialState = {
    data: [],
    loading: true,
    error: '',
    totalCount: 0,
    pages: 1,
};

export function automations(state = initialState, action) {
    switch (action.type) {
        case automationsConstants.AUTOMATIONS_FETCH:
            return { ...state, loading: true, error: '' };
        case automationsConstants.AUTOMATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
                error: '',
            };
        case automationsConstants.AUTOMATIONS_ERROR:
            return { ...state, error: action.message, loading: false };
        default:
            return state;
    }
}
